import {useFirstRender} from '@hooks/useFirstRender';
import {Paper} from '@mui/material';
import classNames from 'classnames';
import {ComponentProps, ForwardedRef, PropsWithoutRef, forwardRef} from 'react';
import {MeinScrollbar} from '..';
import styles from './MeinScrollbarForMui.module.css';

export const MeinScrollbarForMui = forwardRef(function MeinScrollbarForMui(
    {
        children,
        className,
        ...props
    }: PropsWithoutRef<ComponentProps<typeof Paper>>,
    ref: ForwardedRef<HTMLDivElement>,
) {
    // When used inside Mui Select component, scroll position doesn't start
    // at 0 in Chrome. When scrollTop and translateContentSizeYToHolder is
    // provided, scroll position resets to 0 on every rerender. So we
    // set the initial scrollTop to 0 for first render only to avoid both
    // problems.
    const isFirstRender = useFirstRender();

    return (
        <div
            ref={ref}
            className={classNames(className, styles.paper)}
            {...props}
        >
            <MeinScrollbar
                scrollTop={isFirstRender ? 0 : undefined}
                className={styles.scroll}
                translateContentSizeYToHolder
                translateContentSizeXToHolder
            >
                {children}
            </MeinScrollbar>
        </div>
    );
});
